// assets
import { IconLayoutDashboard, IconHome, IconMessageReport } from '@tabler/icons';

const icons = {
    IconHome,
    IconLayoutDashboard,
    IconMessageReport
};

const adminDashboardPages = {
    id: 'admin-dashboard-pages',
    title: 'Dashboards',
    icon: icons.IconKey,
    type: 'group',
    children: [
        {
            id: 'dashboard',
            title: 'Staff Dashboard',
            icon: icons.IconHome,
            type: 'item',
            url: '/dashboard',
            breadcrumbs: false
        },
        {
            id: 'admin-dashboard-page',
            title: 'Admin Dashboard',
            icon: icons.IconLayoutDashboard,
            type: 'item',
            url: '/admin-dashboard-page'
        },
        {
            id: 'bin',
            title: 'User Bin Page',
            icon: icons.IconMessageReport,
            type: 'item',
            url: '/bin',
            breadcrumbs: true
        },
    ]
};

export default adminDashboardPages;
